module.exports = __webpack_public_path__ + "img/developer.368bf82a.png";